import { render } from "./QuestionAndAnser.vue?vue&type=template&id=26980ae3&scoped=true"
import script from "./QuestionAndAnser.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnser.vue?vue&type=script&lang=js"

import "./QuestionAndAnser.vue?vue&type=style&index=0&id=26980ae3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26980ae3"]])

export default __exports__